export const reCaptchaKey = process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY || '';

const getRedirectSignIn = (): string => {
    if (typeof window === 'undefined') return process.env.NEXT_PUBLIC_REDIRECT_SIGN_IN || '';
    const hostname = window.location.hostname;
    if (hostname === 'app.tamnuni.com') return 'https://app.tamnuni.com/app';
    if (hostname === 'talent-frontend-preview.vercel.app') return 'https://talent-frontend-preview.vercel.app/app';
    return process.env.NEXT_PUBLIC_REDIRECT_SIGN_IN || '';
};

const getRedirectSignOut = (): string => {
    if (typeof window === 'undefined') return process.env.NEXT_PUBLIC_REDIRECT_SIGN_OUT || '';
    const hostname = window.location.hostname;
    if (hostname === 'app.tamnuni.com') return 'https://app.tamnuni.com/';
    if (hostname === 'talent-frontend-preview.vercel.app') return 'https://talent-frontend-preview.vercel.app/';
    return process.env.NEXT_PUBLIC_REDIRECT_SIGN_OUT || '';
};

export const amplifyConfig = {
    ssr: false,
    Auth: {
        region: process.env.NEXT_PUBLIC_AWS_REGION,
        userPoolId: process.env.NEXT_PUBLIC_USER_POOL_ID,
        userPoolWebClientId: process.env.NEXT_PUBLIC_USER_POOL_CLIENT_ID,
        oauth: {
            domain: process.env.NEXT_PUBLIC_AUTH_DOMAIN,
            scope: ['email', 'profile', 'openid'],
            redirectSignIn: getRedirectSignIn(),
            redirectSignOut: getRedirectSignOut(),
            responseType: 'code',
        },
    },
};

export const isProduction = process.env.NODE_ENV === 'production';
